import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
@Injectable()
export class CacheService {

  constructor() { }

  static getToken() {
    // return this.getCookie('token');
    return localStorage.getItem("token");
  }
  static setLoginStatus(status: any) {
    return localStorage.setItem("LoginStatus", status);
  }
  static getLoginStatus(){
    return localStorage.getItem("LoginStatus");
  }
  static getOtp() {
    return localStorage.getItem("otp");
  }
  static getregisteredemail() {
    return localStorage.getItem("registeredemail");
  }
  static setToken(token: any) {
    //  this.setCookie("token", token, 2);
    return localStorage.setItem("token", token);
  }
  static setOtp(otp: any) {
    return localStorage.setItem("otp", otp);
  }
  static setRegisteredEmail(otp: any) {
    return localStorage.setItem("registeredemail", otp);
  }
  static setUsername(user: any) {
    localStorage.setItem("userName", JSON.stringify(user));
  }
  static setEmployeeImg(img:any){
    localStorage.setItem("currentEmployeeImg", JSON.stringify(img));
  }
  static getEmployeeImg() {
    return JSON.parse(localStorage.getItem("currentEmployeeImg"));
  }
  static getUsername() {
    return JSON.parse(localStorage.getItem("userName"));
  }

  static setAgancy(agancy: any) {
    localStorage.setItem("agancy", JSON.stringify(agancy));
  }

  static getAgancy() {
    return JSON.parse(localStorage.getItem("agancy"));
  }


  static getEmail(): string {
    let token = CacheService.getToken()
    if (!token)
      return null
    let claims = token.split('.')[1];
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);
    let email = decodedClaims['email'];
    return email
  }

  static getUserId(): string {
    let token = CacheService.getToken()
    if (!token)
      return null
    let claims = token.split('.')[1];
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);

    let id = decodedClaims['sub'];
    return id
  }
  static getFullName(): string {
    let token = CacheService.getToken();
    if (!token) return null;

    let claims = token.split('.')[1];
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);

    let givenName = decodedClaims['given_name'];

    return givenName;
  }
  static getRole(): any {
    let token = CacheService.getToken();
    if (!token) return null;

    let claims = token.split('.')[1];
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);

    let givenName = decodedClaims['role'];
    // Assuming the given_name is encoded in UTF-8

    return givenName;
  }

  static IsAuthorize(roles: Array<string>): boolean {
    if(roles == undefined){
      return true;
    }
    let userRoles = this.getRole();

    var atLeastOneExists1 = roles.some(role => userRoles.includes(role));

    const atLeastOneExists = (Array.isArray(userRoles) && userRoles.some(role => roles.includes(role))) ?? false;

    return atLeastOneExists1;
}

  static getCompanyIds(): string[] {
    let token = CacheService.getToken()
    if (!token)
      return null
    let claims = token.split('.')[1]
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);
    let companyIds = decodedClaims['companyId'];
    return companyIds;
  }
  static getAgnecyId(): string {
    let token = CacheService.getToken()
    if (!token)
      return null
    let claims = token.split('.')[1]
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);
    let agencyIds = decodedClaims['agencyId'];
    return agencyIds;
  }

  static getAgencyCode(): string {
    let token = CacheService.getToken()
    if (!token)
      return null
    let claims = token.split('.')[1]
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);
    let agencyCode = decodedClaims['agencyCode'];
    return agencyCode;
  }
  

  // static getGovernmentAgenciesUserId(): string{
  //   let token = CacheService.getToken()
  //   if (!token)
  //     return null
  //   let claims = token.split('.')[1]
  //   const decodedClaimsJson = Base64.decode(claims);
  //   const decodedClaims = JSON.parse(decodedClaimsJson);
  //   let agencyIds = decodedClaims['governmentAgenciesUserId'];
  //   return agencyIds;
  // }
  static getAgencyName(): string {
    let token = CacheService.getToken();
    if (!token) return null;

    let claims = token.split('.')[1];
    const decodedClaimsJson = Base64.decode(claims);
    const decodedClaims = JSON.parse(decodedClaimsJson);

    let givenName = decodedClaims['agencyName'];
    // Assuming the given_name is encoded in UTF-8
    return givenName;
  }


  static getCurrentLanguage(): string {
    // var currentLang = localStorage.getItem("currentLang") ? localStorage.getItem("currentLang") : "en";
    // this.setCurrentLanguage(currentLang);
    return localStorage.getItem("currentLang") ? localStorage.getItem("currentLang") : "en";
  }

  static setCurrentLanguage(toLang: string) {
    localStorage.setItem("currentLang", toLang);
  }
  static setRelationType(relationType: string) {
    localStorage.setItem("relationType", relationType);
  }

  static setCurrentCompany(crn: string) {
    localStorage.setItem("CurrentCompany", crn);
  }
  static getCurrentCompany() {
    return localStorage.getItem("CurrentCompany");
  }



  static getMyCurrenCompanyData():any {
    localStorage.getItem("CurrenCompanyData");
  }

  static setMyCurrenCompanyData(company: any) {
    localStorage.setItem("CurrenCompanyData", company);
  }


  static getRelationType() {
    return localStorage.getItem("relationType");
  }
  static clearCache() {
    this.deleteCookie("token")
    //localStorage.removeItem("token");
    localStorage.removeItem('userName');
    localStorage.clear();
  }

  static setShowHeader(show: string) {
    localStorage.setItem("showHeader", show);
  }

  static getShowHeader() {
    localStorage.getItem("showHeader");
  }

  static getCompanyLogin() {
    localStorage.getItem("isCompanyLogin");
  }

  static setCompanyLogin(crn: string) {
    localStorage.setItem("isCompanyLogin", crn);
  }


  static setCookie(name: string, value: string, days: number): void {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;Secure`;
  }

  static getCookie(name: string): string | null {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${name}=`)) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }

  static deleteCookie(name: string): void {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;Secure`;
  }
}

